import { CLOTHING_ITEM_DEFINITIONS } from "./definitions/clothing.js";
import { ELECTRONIC_ITEM_DEFINITIONS } from "./definitions/electronics.js";
import { FOOD_ITEM_DEFINITIONS } from "./definitions/food.js";
import { MATERIAL_ITEM_DEFINITIONS } from "./definitions/materials.js";
import { MEDICAL_ITEM_DEFINITIONS } from "./definitions/medical.js";
import { MISC_ITEM_DEFINITIONS } from "./definitions/misc.js";
import { TOOL_ITEM_DEFINITIONS } from "./definitions/tools.js";
import { WATER_ITEM_DEFINITIONS } from "./definitions/water.js";
import { validateItemDefinitions } from "./validation.js";
export const ITEM_CATALOG_VERSION = 2;
const sourceDefinitions = [
    ...CLOTHING_ITEM_DEFINITIONS,
    ...FOOD_ITEM_DEFINITIONS,
    ...WATER_ITEM_DEFINITIONS,
    ...MEDICAL_ITEM_DEFINITIONS,
    ...MATERIAL_ITEM_DEFINITIONS,
    ...ELECTRONIC_ITEM_DEFINITIONS,
    ...TOOL_ITEM_DEFINITIONS,
    ...MISC_ITEM_DEFINITIONS,
];
export const ITEM_CATALOG = validateItemDefinitions(sourceDefinitions);
export const ITEM_DEFINITIONS = Object.freeze([...ITEM_CATALOG.values()]);
export const ITEM_CATALOG_HASH = `fnv1a-${fnv1a(stableCatalogString(ITEM_DEFINITIONS))}`;
export function getItemDefinition(id) {
    return ITEM_CATALOG.get(id);
}
export function requireItemDefinition(id) {
    const definition = ITEM_CATALOG.get(id);
    if (!definition)
        throw new Error(`Unknown item definition: ${id}`);
    return definition;
}
export function buildItemCatalog(definitions) {
    return validateItemDefinitions(definitions);
}
function stableCatalogString(definitions) {
    return JSON.stringify([...definitions]
        .sort((left, right) => left.id.localeCompare(right.id))
        .map((definition) => ({
        ...definition,
        tags: [...definition.tags].sort(),
    })));
}
function fnv1a(value) {
    let hash = 0x811c9dc5;
    for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash.toString(16).padStart(8, "0");
}
